import { render, staticRenderFns } from "./LogbookView.vue?vue&type=template&id=cde2f796&"
import script from "./LogbookView.vue?vue&type=script&lang=js&"
export * from "./LogbookView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports